import { SiteRoleOptionsResource } from '../resources/SiteRoleOptions';

export function filter(siteRole: string): string {
  const translatedSiteRole = SiteRoleOptionsResource.instance.getSiteRoleName(siteRole)();
  return siteRole ? translatedSiteRole : '';
}
